export default __webpack_public_path__ + "static/media/q10_step1.350b8d72.png";